import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore, type Role } from '@/stores/auth.store';

interface Props {
  children: React.ReactNode;
  roles?: Role[];
}

export function ProtectedRoute({ children, roles }: Props) {
  const { user, tokens } = useAuthStore();
  const location = useLocation();

  if (!user || !tokens) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
